import React from 'react';

import { useIntl } from 'react-intl';

import PageObject from '@atlaskit/object/page';

import SelectFilter from '../../../../../common/ui/filters/select-filter';
import { createOptionLabelFormatter } from '../../../../../common/ui/filters/select-filter/option-label';
import { useSelectFilter } from '../../../../../controllers/filters';
import { filter as contentFilter } from '../../../../../controllers/store/search/filters/content';

import { i18n } from './messages';

const formatContentIconOptionLabel = createOptionLabelFormatter(({ option }) => (
	<PageObject label={option.label} />
));

const ContentFilter = (): React.JSX.Element | null => {
	const { formatMessage } = useIntl();

	const [
		filterData,
		{ loadInitialOptions, setLookupInput, setOption, clearLookupInput, clearOptions },
	] = useSelectFilter({
		filterId: contentFilter.id,
	});

	if (!filterData) {
		return null;
	}

	const {
		isLoading,
		suggestedOptions,
		selectedOptions,
		options,
		isLookupDefined,
		lookupInput,
		isLookupActive,
	} = filterData;

	const groupedOptions = [
		{
			label: formatMessage(i18n.confluenceFilterLabelSelected),
			options: selectedOptions,
		},
		{
			label: formatMessage(i18n.confluenceFilterLabelUnselected),
			options: suggestedOptions,
		},
	];

	return (
		<SelectFilter
			canClearFilter
			onDropdownOpen={loadInitialOptions}
			onDropdownClose={clearLookupInput}
			onSearchInputChange={setLookupInput}
			onSelectChange={setOption}
			options={isLookupActive ? options : groupedOptions}
			selectedOptions={selectedOptions}
			label={formatMessage(i18n.content)}
			placeholder={formatMessage(i18n.confluenceFilterPlaceholder)}
			filterOrControlId={'content'}
			isLoading={isLoading}
			isSearchable={isLookupDefined}
			searchInput={lookupInput}
			formatOptionLabel={formatContentIconOptionLabel}
			onClearOptions={clearOptions}
		/>
	);
};

export default ContentFilter;
